import { ReactNode } from 'react'

interface DrawerSectionProps {
  title: ReactNode
  count?: ReactNode
  action?: ReactNode
  children: ReactNode
}

const DrawerSection = ({ title, count, action, children }: DrawerSectionProps) => (
  <section className="c-flex c-flex-col c-gap-4 c-border-t c-border-grey-200 c-pt-4 first:c-border-t-0 first:c-pt-0">
    <header className="c-flex c-items-center c-justify-between c-gap-2">
      <h3 className="c-m-0 c-text-base c-font-semibold c-leading-[22px] c-text-black">
        {title}
        {count !== undefined && <span className="c-ml-1">{count}</span>}
      </h3>
      {action}
    </header>
    <div className="c-flex c-flex-col c-gap-2 c-rounded-2xl c-bg-drawer-surface c-p-4">{children}</div>
  </section>
)

export { DrawerSection }
